import { render, staticRenderFns } from "./TaskConfig.vue?vue&type=template&id=487190b7&scoped=true"
import script from "./TaskConfig.vue?vue&type=script&lang=js"
export * from "./TaskConfig.vue?vue&type=script&lang=js"
import style0 from "./TaskConfig.vue?vue&type=style&index=0&id=487190b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487190b7",
  null
  
)

export default component.exports